import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const generateRemoteUrl = (selectedAuthors: (string | number)[], reloadKey?: number): string => {
  let url = "demos/records";

  if (selectedAuthors && selectedAuthors.length > 0) {
    url += `?authors=${selectedAuthors.join(",")}`;
  }

  if (reloadKey !== undefined) {
    url += `${url.includes("?") ? "&" : "?"}reload=${reloadKey}`;
  }

  return url;
};

export function fetchAuthors(language: string, setAuthors: Function, setLoadingAuthors: Function) {
  setLoadingAuthors(true);

  ApiService.get("staff-members?order_by=full_name")
    .then((response) =>
      setAuthors(
        response.data.staff_members.map((member: any) => ({
          id: member.id,
          full_name: member.full_name,
          user: member.user,
        }))
      )
    )
    .catch((error) => {
      console.error("Error fetching staff members:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => {
      setLoadingAuthors(false);
    });
}
